
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDirection } from '@/providers/DirectionProvider';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle
} from '@/components/ui/dialog';
import PhoneVerification from '@/components/auth/PhoneVerification';

interface PhoneVerificationDialogProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  userPhone: string;
  onVerified: () => void;
}

const PhoneVerificationDialog: React.FC<PhoneVerificationDialogProps> = ({
  isOpen,
  onOpenChange,
  userPhone,
  onVerified
}) => {
  const { t } = useTranslation();
  const { direction } = useDirection();

  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md" dir={direction}>
        <DialogHeader>
          <DialogTitle>{t('dialogs.phoneVerification.title')}</DialogTitle>
          <DialogDescription>
            {t('dialogs.phoneVerification.description')}
          </DialogDescription>
        </DialogHeader>
        <PhoneVerification
          phone={userPhone}
          onVerified={onVerified}
        />
      </DialogContent>
    </Dialog>
  );
};

export default PhoneVerificationDialog;
